import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HddOutlined, MinusCircleOutlined, ReloadOutlined, ShrinkOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { isDefaultSchema } from "../others/isDefaultSchema.js";
import { useStores } from "../store/stores.js";
import { __ } from "../utils/i18n.js";
const ThumbnailsList = observer(()=>{
    const { single } = useStores().attachmentsStore;
    if (!single) {
        return null;
    }
    const { rows, filesizeSumFormat, usedSchema } = single;
    return /*#__PURE__*/ _jsxs("div", {
        className: "rtg-container",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    __("Total space in the file system"),
                    /*#__PURE__*/ _jsx("div", {
                        children: filesizeSumFormat
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "clear"
                    })
                ]
            }),
            Object.keys(rows).map((size)=>({
                    size,
                    ...rows[size]
                })).map(({ size, href, dimension, status, unused, filesFound, registeredSize, crop, needsRegeneration })=>/*#__PURE__*/ _jsxs("div", {
                    className: unused ? "unused" : undefined,
                    children: [
                        needsRegeneration && /*#__PURE__*/ _jsx(ReloadOutlined, {
                            style: {
                                marginRight: 5
                            },
                            title: __("The current thumbnail size differs from registered size.")
                        }),
                        !filesFound && !unused && /*#__PURE__*/ _jsx(HddOutlined, {
                            style: {
                                marginRight: 5
                            },
                            title: __("The file does no longer exist on filesystem.")
                        }),
                        !registeredSize && /*#__PURE__*/ _jsx(MinusCircleOutlined, {
                            style: {
                                marginRight: 5
                            },
                            title: __("This image size is not longer registered in your WordPress.")
                        }),
                        crop && /*#__PURE__*/ _jsx(ShrinkOutlined, {
                            style: {
                                marginRight: 5
                            },
                            title: __("This image size is cropped.")
                        }),
                        href ? /*#__PURE__*/ _jsx("a", {
                            href: href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: size
                        }) : /*#__PURE__*/ _jsx("span", {
                            children: size
                        }),
                        "\xa0",
                        dimension,
                        /*#__PURE__*/ _jsx("div", {
                            children: status
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "clear"
                        })
                    ]
                }, size)),
            !isDefaultSchema(usedSchema) && /*#__PURE__*/ _jsxs("div", {
                children: [
                    __("Used path and filename"),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("code", {
                            children: usedSchema
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "clear"
                    })
                ]
            })
        ]
    });
});
export { ThumbnailsList };
